export const iconFontAwesomeToggleCircleCheck = (
	<i className="fa-solid fa-circle-check"></i>
);
